import * as Types from './types';
import { actionTypes } from './constants';

export const startIntegration = (): Types.ISportsbookStartIntegrationAction => ({
    type: actionTypes.SPORTSBOOK_START
});

export const stopIntegration = (): Types.ISportsbookStopIntegrationAction => ({
    type: actionTypes.SPORTSBOOK_STOP
});

export const startRendering = (): Types.ISportsbookAppRenderStartAction => ({
    type: actionTypes.SPORTSBOOK_RENDER_START
});

export const updateBalances = (balances: Types.IBalance[]): Types.ISportsbookUpdateBalancesAction => ({
    type: actionTypes.SPORTSBOOK_BALANCES_UPDATE,
    payload: balances
});

export const setIntegrationScriptFetching = (): Types.ISportsbookSetIntegrationScriptFetchingAction => ({
    type: actionTypes.SPORTSBOOK_INTEGRATION_SCRIPT_FETCHING
});

export const setIntegrationScriptFetched = (): Types.ISportsbookSetIntegrationScriptFetchedAction => ({
    type: actionTypes.SPORTSBOOK_INTEGRATION_SCRIPT_FETCHED
});

export const setIntegrationScriptError = (): Types.ISportsbookSetIntegrationScriptErrorAction => ({
    type: actionTypes.SPORTSBOOK_INTEGRATION_SCRIPT_ERROR
});

export const setAppInitialized = (isInitialized: boolean): Types.ISportsbookSetAppInitializedAction => ({
    type: actionTypes.SPORTSBOOK_INITIALIZED_UPDATE,
    payload: isInitialized
});

export const setAppInitializing = (): Types.ISportsbookSetAppInitializingAction => ({
    type: actionTypes.SPORTSBOOK_INITIALIZING_UPDATE
});

export const setAppInitError = (): Types.ISportsbookSetAppInitErrorAction => ({
    type: actionTypes.SPORTSBOOK_INITIALIZE_ERROR
});
